export default [
    {
		path: '/campaign-tags',
		name: 'Campaign Tags',
		component: () => import('@/views/campaigntag/CampaignTags.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'campaigns'], ['manage', 'campaigns']]
		}
	},
]